<template>
  <div class='TopUpQuery'>
    <Tab :Tab="Tab"></Tab>
    <search-form size='medium'
                 labelWidth='90px'
                 class="SearchForm"
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="searchHandleForm"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Tab from '@/components/Tab.vue'
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
const typeProps = { label: 'name', value: 'id' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Tab,
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      Tab: {
        select: '0',
        pages: [
          {
            name: '未充值',
            id: '0'
          },
          {
            name: '已充值',
            id: '1'
          },
          {
            name: '动态卡充值记录',
            id: '2'
          }
        ],
        handle: () => this.cutPages()
      },

      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '批次号：', prop: 'batchSn', placeholder: '请输入批次号' },
          { type: 'Input', label: '预付卡号：', prop: 'cardNo', placeholder: '请输入预付卡号' },
          { type: 'Input', label: '卡名称：', prop: 'cardName', placeholder: '请输入卡名称' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: typeProps, change: row => '', placeholder: '请选择卡类型' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      activeSearch: [
        { type: 'InputRange', label: '充值次数：', prop: 'startCount', prop1: 'endCount', placeholder: '' },
        { type: 'Input', label: '会员ID：', prop: 'bindAccount', placeholder: '请输入会员ID' },
        { type: 'Input', label: '账号名称：', prop: 'bindAccountName', placeholder: '请输入账号名称' },
      ],
      // searchOneTwo: [{ type: 'Select', label: '卡种类：', prop: 'cardNature',
      //     options: [
      //       // {name:'定额卡', id:0},
      //       {name:'不定额卡', id:1},
      //       {name:'动态充值卡', id:2},
      //     ], props: typeProps, change: row => '', placeholder: '请选择卡种类' }],
      searchThree: [
        // { type: 'Input', label: '充值次数：', prop: 'endCount', placeholder: '请输入充值次数' },
        { type: 'Input', label: '会员ID：', prop: 'bindAccount', placeholder: '请输入会员ID' },
        { type: 'Input', label: '账号名称：', prop: 'bindAccountName', placeholder: '请输入账号名称' },
        { type: 'Select', label: '审核状态：', prop: 'status', options: [
          {name:'待处理',id:0},
          {name:'通过',id:1},
          {name:'驳回',id:2}
        ], props: typeProps, change: row => '', placeholder: '请选择审核状态' },
        { type: 'daterange', label: '充值日期：', prop: 'rechargeDate', span: 12 },
      ],
      cardNatureObj:{
        0: '定额卡',
        1: '不定额卡',
        2: '动态充值卡'
      },
      stateObj:{
        0:'待处理',
        1:'通过',
        2:'驳回'
      },
      Table: { // 表格
        data: [{
          a: '系统自动生成',
          b: '显示卡名称',
          c: 'A类',
          d: '100',
          e: '1',
          f: '2019.12.12 ~ 2020.12.12'
        }],
        TabColumn: [
          [
            { prop: 'batchSn', label: '批次号' },
            { prop: 'cardName', label: '卡名称' },
            { prop: 'cardNo', label: '预付卡号' },
            { prop: 'cardTypeName', label: '卡类型' },
            { prop: 'cardNatureName', label: '卡种类' },
            { prop: 'issuingType', label: '发行方式', slot: true },
            { prop: 'denomination', label: '面值(元)' },
            { prop: 'updateTime', label: '更新日期' }
          ],
          [
            { prop: 'batchSn', label: '批次号' },
            { prop: 'cardName', label: '卡名称' },
            { prop: 'cardNo', label: '预付卡号' },
            { prop: 'cardTypeName', label: '卡类型' },
            { prop: 'cardNatureName', label: '卡种类' },
            { prop: 'issuingType', label: '发行方式', slot: true },
            { prop: 'denomination', label: '合计充值金额' },
            { prop: 'bindAccount', label: '会员ID' },
            { prop: 'bindAccountName', label: '账号名称' },
            { prop: 'rechargedTime', label: '充值日期' },
          ],
          [
            { prop: 'batchSn', label: '批次号' },
            { prop: 'cardName', label: '卡名称' },
            { prop: 'cardNo', label: '预付卡号' },
            { prop: 'cardTypeName', label: '卡类型' },
            { prop: 'cardNatureName', label: '卡种类' },
            { prop: 'rechargeAmount', label: '充值金额' },
            { prop: 'bindAccount', label: '会员ID' },
            { prop: 'bindAccountName', label: '账号名称' },
            { prop: 'createTime', label: '充值日期' },
            { prop: 'statusName', label: '审核状态' },
          ]
        ],
        column: []

      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {

  },
  // 方法集合
  methods: {
    exportFn(e){
      const params = this.handleParams()
      params.pageNum = null 
      params.pageSize = null
      this.$http.rechargeistExport(params).then((res) => {
          if (res.status === 200) {
            this.$message.success('执行成功')
          }else{
            this.$message.error(res.msg)
          }
        })

    },
    cutPages (tab, event) { // 切换tab
      const { Table, Tab } = this
      let searchForm = this.search.searchForm
      
      // Tab.select === '0' ? searchForm.splice(4) : (searchForm.length === 4 && searchForm.splice(4,0,...this.activeSearch))
      if(Tab.select === '0'){
        // searchForm.splice(4)
        this.search.searchForm = searchForm.slice(0,4)
        this.Table.defaultBtn = null
      }
      if(Tab.select === '1'){
        // searchForm.length === 4 && searchForm.splice(4,0,...this.activeSearch)
        this.search.searchForm = searchForm.slice(0,4).concat(...this.activeSearch)
        this.Table.defaultBtn = null
      }
      if(Tab.select === '2'){
        // searchForm.splice(4,0,...this.searchThree)
        this.search.searchForm = searchForm.slice(0,4).concat(...this.searchThree)
        this.Table.defaultBtn = {
          show: true,
          html: '导出',
          handle: (el) => this.exportFn(el)
        }
      }
      this.Table.column = Table.TabColumn[Tab.select]
      this.searchResetForm() // 调用重置
      this.pager.page = 1
      this.searchHandleForm()
    },

    searchHandleForm () { // 查询
      this.getItemList()
    },
    searchResetForm () { // 重置
      this.search.searchData = {}
    },

    handleParams () {
      const { pager, Tab } = this
      let search = null
      if (Tab.select === '0') {
        search = Object.assign(this.search.searchData, { recharged: false, determineValue: false, cardNature: 2 })
      } else {
        search = Object.assign(this.search.searchData, { recharged: true, determineValue: false, cardNature: 2 })
      }
      if(Tab.select === '2'){
        // 动态充值记录查询的 cardNature :2 写死
        let rechargeDate = this.search.searchData.rechargeDate
        search = Object.assign(this.search.searchData, { cardNature: 2,rechargeDateBegin: rechargeDate? rechargeDate[0]:null, rechargeDateEnd: rechargeDate? rechargeDate[1]:null,})
      }
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search
      }
      if(Tab.select === '2'){
        params.rechargeDate = null
      }
      return params
    },

    getItemList () {
      const { Tab } = this
      const params = this.handleParams()
      if(Tab.select === '2'){
        this.$http.getDynamiCardList(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list.map((item) => ({
              ...item,
              bindAccount: (item.bindAccount || item.bindAccount === 'null') ? item.bindAccount : '-',
              cardNatureName: Tab.select === '2' ? this.cardNatureObj[2] : this.cardNatureObj[item.cardNature || 0],
              statusName: this.stateObj[item.status]
            }))
          }
        })
      }else{
        this.$http.getCardPagination(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list.map((item) => ({
              ...item,
              bindAccount: (item.bindAccount || item.bindAccount === 'null') ? item.bindAccount : '-',
              remaining: item.remaining ? item.remaining : '-',
              state: item.state.text,
              stateNo: item.state.value,
              validTime: `${item.validBegin} ~ ${item.validEnd}`,
              cardNatureName: this.cardNatureObj[item.cardNature || 0],
              denomination: Tab.select === '0' ? ((item.cardNature || '') == 2 ? '-' : item.denomination) : item.denomination
            }))
          }
        })
      }
    },
    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.search.searchForm.forEach((item) => {
              if (item.prop == 'cardTypeId') {
                item.options = res.data
              }
            })
          }
        })
    },
    // 初始化
    init () {
      const { Table } = this
      let searchForm = this.search.searchForm
      this.Table.column = Table.TabColumn[0]
      this.search.searchForm = searchForm.slice(0,4)
      this.getCardTypeList()
      this.getItemList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.SearchForm {
  margin-top: -50px;
}
</style>
